import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FetchObjectFooter = ({
  onClose,
  onSave,
  isSaving,
  saveBtnLabel,
  onSaveDisabled,
  onSaveDisabledTooltip
}) => {
  const onSaveBtn = /*#__PURE__*/_jsx(UILoadingButton, {
    use: "primary",
    type: "submit",
    disabled: onSaveDisabled,
    onClick: onSave,
    loading: isSaving,
    "data-test-id": "fetch-object-footer-save-button",
    children: saveBtnLabel || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.fetch-object-panel.footer.buttons.save-text"
    })
  });
  const onCloseBtn = /*#__PURE__*/_jsx(UIButton, {
    use: "secondary",
    type: "submit",
    onClick: onClose,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.fetch-object-panel.footer.buttons.cancel-text"
    })
  });
  return /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [onSaveDisabled && onSaveDisabledTooltip && /*#__PURE__*/_jsx(UITooltip, {
      title: onSaveDisabledTooltip,
      children: onSaveBtn
    }), onSaveDisabled && !onSaveDisabledTooltip && onSaveBtn, !onSaveDisabled && onSaveBtn, onCloseBtn]
  });
};
export default FetchObjectFooter;